"use strict";
export function createHasMismatchUtil(ctx) {
  const withPerformanceLogger = createWithPerformanceLogger({
    logger: ctx.logger,
    name: "hasMismatch",
    filename: "mismatch.ts"
  });
  return withPerformanceLogger(async function hasMismatch(input) {
    const [delegatedResult, isAtomicBatchingSupported] = await Promise.all([
      ctx.delegationService.getIsAddressDelegated(input),
      ctx.getIsAtomicBatchingSupported({
        chainId: input.chainId
      })
    ]);
    const isMismatch = !isAtomicBatchingSupported && delegatedResult.isDelegated;
    if (isMismatch && delegatedResult.delegatedAddress) {
      ctx.onMismatchDetected?.({
        chainId: input.chainId,
        isDelegated: delegatedResult.isDelegated,
        delegatedAddress: delegatedResult.delegatedAddress
      });
    }
    return isMismatch;
  });
}
function createWithPerformanceLogger(ctx) {
  return (fn) => {
    return async (...args) => {
      if (!ctx?.logger || !ctx.filename || !ctx.name) {
        return fn(...args);
      }
      const start = performance.now();
      try {
        const result = await fn(...args);
        const end = performance.now();
        ctx.logger.info(ctx.filename, ctx.name, `${ctx.name} took ${end - start}ms`);
        return result;
      } catch (error) {
        const end = performance.now();
        ctx.logger.error(error, {
          tags: {
            file: ctx.filename,
            function: ctx.name
          },
          extra: {
            duration: end - start
          }
        });
        throw error;
      }
    };
  };
}
